module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<form>\n    <dl class=\'stepped zero\'>\n            <dt>\n                <label for=\'user_name\'>' +
((__t = ( i18next.t('common.name') )) == null ? '' : __t) +
'</label>\n            </dt>\n            <dd>\n                <input class=\'text\' id=\'user_name\' name=\'user[name]\' type=\'text\' value=\'' +
((__t = ( name )) == null ? '' : __t) +
'\'>\n            </dd>\n            <dt>\n                <label for=\'user_email\'>' +
((__t = ( i18next.t('common.email') )) == null ? '' : __t) +
'</label>\n            </dt>\n            <dd>\n                <input class=\'text\' id=\'user_email\' name=\'user[email]\' type=\'text\' value=\'' +
((__t = ( email )) == null ? '' : __t) +
'\'>\n            </dd>\n            ';
 if (WiseMetering.currentUser.isAdministrator() && !myProfile) { ;
__p += '\n                <dt style=\'margin-bottom: 0.5em;\'>\n                    <input ' +
((__t = ( administrator ? 'checked' : '' )) == null ? '' : __t) +
' class=\'vertical-middle\' id=\'user_administrator\' name=\'user[administrator]\' type=\'checkbox\'>\n                    <label for=\'user_administrator\' style=\'text-transform: capitalize;\'>' +
((__t = ( i18next.t('glossary.administrator') )) == null ? '' : __t) +
'</label>\n                </dt>\n                <dt style=\'margin-bottom: 0.5em;\'>\n                    <input ' +
((__t = ( manager ? 'checked' : '' )) == null ? '' : __t) +
' class=\'vertical-middle\' id=\'user_manager\' name=\'user[manager]\' type=\'checkbox\'>\n                    <label for=\'user_manager\' style=\'text-transform: capitalize;\'>' +
((__t = ( i18next.t('glossary.manager') )) == null ? '' : __t) +
'</label>\n                </dt>\n            ';
 } ;
__p += '\n            ';
 if (WiseMetering.currentUser.isSuperUser()) { ;
__p += '\n                <dt style=\'margin-bottom: 0.5em;\'>\n                    <input ' +
((__t = ( hardware_digest_access ? 'checked' : '' )) == null ? '' : __t) +
' class=\'vertical-middle\' id=\'user_hardware_digest_access\' name=\'user[hardware_digest_access]\' type=\'checkbox\'>\n                    <label for=\'user_hardware_digest_access\'>' +
((__t = ( i18next.t('users.hardware_digest_access') )) == null ? '' : __t) +
'</label>\n                </dt>\n                <dt style=\'margin-bottom: 0.5em;\'>\n                    <input ' +
((__t = ( indicators_digest_email ? 'checked' : '' )) == null ? '' : __t) +
' class=\'vertical-middle\' id=\'user_indicators_digest_email\' name=\'user[indicators_digest_email]\' type=\'checkbox\'>\n                    <label for=\'user_indicators_digest_email\'>' +
((__t = ( i18next.t('users.receive_indicators_digest') )) == null ? '' : __t) +
'</label>\n                </dt>\n            ';
 } ;
__p += '\n    </dl>\n</form>\n';

}
return __p
}